/**
 * @module:  支付 页面汇总
 * @author: Liang Huang 
 * @date: 2020-06-02 15:29:53 
 */

import { lazy } from 'react';
import { retry } from '@src/utils/tool';

// // 订单支付
// export const OrderPay = lazy(() => retry(() => import('@src/pages/Payment/OrderPay')));
// 订单详情
export const OrderStatus = lazy(() => retry(() => import('@src/pages/Payment/OrderStatus')));
// 服务协议
export const OrderProtocol = lazy(() => retry(() => import('@src/pages/Payment/Protocol')));
// 退款详情
export const OrderReback = lazy(() => retry(() => import('@src/pages/Payment/OrderReback')));

